import { isNil } from 'lodash-es';
import { useEffect, useState } from 'react';

import { useModuleLoader } from 'hooks/loader';
import services from 'services';
import { Json, ModuleConfig } from 'types';
import { getAvailableModules, isPluginModule } from 'utils';
import loadPlugins, { PluginModuleConfigWithKey } from 'utils/loadPlugins';

export const isPreloginPluginModuleWithKey = (module: ModuleConfig): module is PluginModuleConfigWithKey =>
  isPluginModule(module) && !isNil(module.key) && !!module.prelogin;

const usePreloginPlugins = () => {
  const moduleLoader = useModuleLoader();
  const [initialized, setInitialized] = useState(false);

  const { load: loadModule, getModulesMap } = moduleLoader;
  useEffect(() => {
    const availableModules = getAvailableModules();
    loadPlugins({
      pluginsToLoad: availableModules.filter(isPreloginPluginModuleWithKey),
      methods: ['prelogin'],
      loadModule,
      getModulesMap,
    }).then((pluginsLoadErrors) => {
      if (pluginsLoadErrors.length) {
        services.appFrame.error.main.addError({
          title: 'errors.plugin_load_error.title',
          message: 'errors.plugin_load_error.message',
          details: {
            type: 'PRELOGIN_PLUGIN_LOAD_ERROR',
            timestamp: new Date(),
            errors: pluginsLoadErrors as Json,
          },
          actions: [
            {
              id: 'reload',
              text: 'errors.plugin_load_error.actions.reload',
              onClick: () => window.location.reload(),
            },
          ],
        });
        return;
      }
      setInitialized(true);
    });
  }, [loadModule, getModulesMap]); // NOTE: all these references must be static (constants)

  return initialized;
};

export default usePreloginPlugins;
